import React, { useEffect, useState } from 'react'
import './regionPhoneSearch.scss'
import constant from '../../../constants/constant';

const Index = ({ setIsOpen, searchCallBack, placeholder, className, heading, buttonStyle, refs }: any) => {
    const [searchVal, setSearchVal] = useState('')
    const [searchClicked, setSearchClicked] = useState(false);

    // Retrieve region code from localStorage and convert it to a number
    const regionCode: boolean = Number(localStorage.getItem("store_region")) === constant.STORE_REGION.KUWAIT;
    // end

    // Country code drop down
    const CountryDropDown = (): JSX.Element => {
        const selectedCountry = regionCode
            ? constant?.COUNTRY_CODES[1]
            : constant?.COUNTRY_CODES[0];

        return (
            <span className="d-flex input-group-text align-items-center gap-2" id="addon-wrapping">
                <span>{selectedCountry?.flag}</span>
                <span>{selectedCountry?.code}</span>
            </span>
        );
    };
    // end

    // to handle the onchange function
    const handleOnchange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value as string;
        const maxLength = regionCode ? constant.KUWAIT_NUMBER_LENGTH : constant.INDIA_NUMBER_LENGTH;

        if (inputValue.length <= maxLength) {
            setSearchVal(e.target.value?.replace(/\s/g, ''))
        }
    };
    // end

    useEffect(() => {
        if (searchClicked) {
            if (searchVal?.length > 0) {
                searchCallBack(searchVal)
                setIsOpen(true)
            }
        }
        setSearchClicked(false)
    }, [searchClicked])

    return (
        <div className='d-flex position-relative'>
            <div className="input-group" style={{ zIndex: 1 }}>
                {/* Country Dropdown as input-group prepend */}
                <CountryDropDown
                />
                {/* Text input */}
                <input
                    ref={refs}
                    type="text"
                    name="keyword"
                    id="search"
                    value={searchVal}
                    className={`form-control ${className} region-new-custom-search`}
                    placeholder={placeholder || 'Search'}
                    autoComplete="off"
                    onChange={e => handleOnchange(e)}
                />
            </div>
            {/* Button */}
            <button
                className={`position-absolute shadow-none border-0 add-product-btn ${buttonStyle}`}
                type="button"
                style={{ zIndex: 2 }}
                onClick={() => setSearchClicked(true)}
            >
                {heading}
            </button>
        </div>
    )
}

export default Index